import FormatosReanimate from '../res/formatosReanimate';
import CryptoJS from 'crypto-js'
import { resizedataURL } from './printElement';

export function base64ToBlob(base64) {
  const mimeMatch = base64.match(/^data:(image\/[a-zA-Z]+);base64,/);
  if (!mimeMatch) {
      console.error('Base64 inválido');
      return;
  }
  const mime = mimeMatch[1];
  const byteString = atob(base64.split(',')[1]);
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const intArray = new Uint8Array(arrayBuffer);
  for (let i = 0; i < byteString.length; i++) {
      intArray[i] = byteString.charCodeAt(i);
  }
  return new Blob([intArray], { type: mime });
}

export function ObjectToHtml (master, blob = false) {
  try {
    if (master.estatico) return HtmlEstatico(master);
    else return HtmlAnimation(master, blob);
  } catch {}
}

export function HtmlAnimation(master, blob) {
  if (master.width === undefined) return;
  var banner = JSON.parse(JSON.stringify(master));
  try {
    var html = `<html>
  <head>
  <meta charset="UTF-8">
  <meta name="apple-mobile-web-app-capable" content="yes">
  <meta name="viewport" content="minimum-scale=1,maximum-scale=1,width=device-width,user-scalable=no">
  <meta name="ad.size" content="width=${banner.width},height=${banner.height}">
      <!-- /* a cima dimensão do banner */ -->
  <script type="text/javascript">
      var clickTag = "http://www.google.com"
  </script>
  <title>Reanimate_${banner.width}x${banner.height}</title>
      <!-- /* a nomeclatura da peça */ -->
  <style>
    body {
      margin: 0;
      padding: 0;
      width: ${banner.width}px;
      height: ${banner.height};
      position: relative;
    }

    #clickArea {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 999
    }

    #clickArea img {
        border: 0
    }

    #banner {
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
        -webkit-user-select: none;
        -ms-user-select: none;
        user-select: none;
        box-sizing: border-box;
        overflow: hidden;
        position: relative;
        width: ${banner.width}px;
        height: ${banner.height}px;
        top: 0;
        left: 0;
        cursor: pointer;
        background-color: ${banner.backgroundColor === undefined ? '#fff' : banner.backgroundColor};
        border: ${banner.bannerBorder === undefined ? 'solid 0.75px  #aeaeae': banner.bannerBorder };
    }
    ${!banner.estatico ? `
    #banner:after {
        position: absolute;
        content: '';
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 900
    }

    #banner:before {
        position: absolute;
        content: '';
        left: 0;
        top: 0;
        width: calc(100% - 2px);
        height: calc(100% - 2px);
        z-index: 901;
        border: solid 1px #000
    }` : ``}
    `
    banner.elements.forEach(async (el) => {
      if (el.properties) {
      html += `
        .${el.id} {
          ${!el.enabled? `display: none;` : ""}
          ${blob ? `background: url('${el.properties.blob}') no-repeat;` : ""}
          ${el.properties.background && !blob ? `background: url('${el.properties.background}') no-repeat;` : ""}
          width: ${Math.ceil(el.properties.width * el.properties.scale / 100)}px;
          height: ${Math.ceil(el.properties.height * el.properties.scale / 100)}px;
          left: ${el.parent ? el.properties.scale * el.properties.left / 100 : el.properties.left}px;
          top: ${el.parent ? el.properties.scale * el.properties.top / 100 : el.properties.top}px;
          ${el.properties.opacity !== null ? `opacity: ${el.properties.opacity};` : ""}
          ${el.properties.zIndex !== null ? `z-index: ${el.properties.zIndex};` : ``}
          ${el.properties.position ? `position: ${el.properties.position};` : ""}
          transform: ${el.properties.transform ? `${el.properties.transform}` : ``} ${el.properties.rotate ?  `rotate(${el.properties.rotate}deg)` : ""};
          ${el.properties.transformOrigin ? `transform-origin: ${el.properties.transformOrigin};` : ""}
          ${el.properties.color ? `color: ${el.properties.color};` : ""}
          ${el.properties.backgroundColor ? `background-color: ${el.properties.backgroundColor};` : ""}
          ${el.properties.fontSize ? `font-size: ${el.properties.fontSize};` : ""}
          ${el.properties.textAlign ? `text-align: ${el.properties.textAlign};` : ""}
          background-size: ${el.reduce ? 'none' : el.type === 'bg' ? 'cover' : 'contain'};
        }`}
      });
  
    html += "</style>";
    html += banner.animation;
    html += "</head>";
    html += banner.body;
    html += "</html>";
    return html;
  } catch (error) {
    console.log(error)
    return null;
  }
}

export function HtmlEstatico(master) {
  if (master.width === undefined) return;
  var banner = JSON.parse(JSON.stringify(master));
  try {
    var html = `<html>
  <head>
  <meta charset="UTF-8">
  <meta name="apple-mobile-web-app-capable" content="yes">
  <meta name="viewport" content="minimum-scale=1,maximum-scale=1,width=device-width,user-scalable=no">
  <meta name="ad.size" content="width=${banner.width},height=${banner.height}">
      <!-- /* a cima dimensão do banner */ -->
  <script type="text/javascript">
      var clickTag = "http://www.google.com"
  </script>
  <title>Reanimate_${banner.width}x${banner.height}</title>
      <!-- /* a nomeclatura da peça */ -->
  <style>
    body {
      margin: 0;
      padding: 0
    }

    #clickArea {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 999
    }

    #clickArea img {
        border: 0
    }

    #banner {
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
        -webkit-user-select: none;
        -ms-user-select: none;
        user-select: none;
        box-sizing: border-box;
        overflow: hidden;
        position: relative;
        width: ${banner.width}px;
        height: ${banner.height}px;
        top: 0;
        left: 0;
        cursor: pointer
    }
    ${!banner.estatico ? `
    #banner:after {
        position: absolute;
        content: '';
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 900
    }

    #banner:before {
        position: absolute;
        content: '';
        left: 0;
        top: 0;
        width: calc(100% - 2px);
        height: calc(100% - 2px);
        z-index: 901;
        border: solid 1px #000
    }` : ``}
    `
    banner.elements.forEach(async (el) => {
      if (el.properties) {
      html += `
        .${el.id} {
          ${!el.enabled? `display: none;` : ""}
          ${el.properties.background ? `background: url(${el.properties.background}) no-repeat;` : ""}
          width: ${Math.ceil(el.properties.width * el.properties.scale / 100)}px;
          height: ${Math.ceil(el.properties.height * el.properties.scale / 100)}px;
          left: ${el.parent ? el.properties.scale * el.properties.left / 100 : el.properties.left}px;
          top: ${el.parent ? el.properties.scale * el.properties.top / 100 : el.properties.top}px;
          ${el.properties.zIndex !== null ? `z-index: ${el.properties.zIndex};` : ``}
          ${el.properties.position ? `position: ${el.properties.position};` : ""}
          transform: ${el.properties.transform ? `${el.properties.transform}` : ``} ${el.properties.rotate ?  `rotate(${el.properties.rotate}deg)` : ""};
          ${el.properties.transformOrigin ? `transform-origin: ${el.properties.transformOrigin};` : ""}
          ${el.properties.color ? `color: ${el.properties.color};` : ""}
          ${el.properties.backgroundColor ? `background-color: ${el.properties.backgroundColor};` : ""}
          ${el.properties.fontSize ? `font-size: ${el.properties.fontSize};` : ""}
          ${el.properties.textAlign ? `text-align: ${el.properties.textAlign};` : ""}          
          background-size: ${el.reduce ? 'none' : el.type === 'bg' ? 'cover' : 'contain'};
        }`}
      });
  
    html += "</style></head>";
    html += banner.body;
    html += "</html>";
    return html;
  } catch (error) {
    console.log(error)
    return null;
  }
}

export function GetMasterFormat (banner) {
  if (!banner) return null;
  const formats = FormatosReanimate();
  formats.forEach(format => {
    if (format.width === banner.width && format.height === banner.height) {
      return format.type;
    }
  });
  if (banner.width === banner.height) return "Quadrado";
  if (banner.height / banner.width > 1.5) return "Vertical";
  return "Horizontal";
}

export function GetHtmlSize(html) { 
  var textFile = null,
  makeTextFile = function (text) {
    var data = new Blob([text], {type: 'text/plain'});

    // If we are replacing a previously generated file we need to
    // manually revoke the object URL to avoid memory leaks.
    if (textFile !== null) {
      window.URL.revokeObjectURL(textFile);
    }

    textFile = window.URL.createObjectURL(data);

    // returns a URL you can use as a href
    return (data.size / 1024).toFixed(2);
  };
  return makeTextFile(html)
}


export function BannerJson(banner, type, master) {
  return {
    "key" : banner.hash,
    "creative" : type,
    "format": `${banner.width}x${banner.height}`,
    "file_title": banner.psd,
    "type": master ? "master" : "replica"
  }
}


export function CreateHash(banner) {  
  var hash_string = `${Date.now()}_${banner.psd}_${banner.width}_${banner.height}`
  var hash = CryptoJS.MD5(hash_string).toString();
  return hash;
}